export default __webpack_public_path__ + "static/media/pangolin.ebb000f9.svg";